import { gql } from 'graphql.macro';

export const GetIssueById = gql`
    query GetIssue($id: Int!) {
        issue: issueById(id: $id) {
            observationId
            uniqueRecordId
            companyId
            concernLevel
            locationType
            offSiteLocation {
                customerSiteName
                locationDescription
                locationLatitude
                locationLongitude
            }
            depotPcId
            observationCategoryId
            observationCategoryName
            whatHappened
            howToStop
            anonymousEntry
            reporterType
            reportedBy {
                reporterContactName
                reporterPhoneNumber
                reporterEmail
            }
            observationStatus
            lastModified
            incidentDate
            emailedFileIds
            completion {
                actionTaken
                closureReason
                closeDate
                employeeId
                hasAttachments
            }
            processId
            reachId
        }
    }
`;
